import Checkbox from '@mui/material/Checkbox'
import { useContext } from 'react'
import { MdOutlineProductionQuantityLimits } from 'react-icons/md'
import { ModalTotalContext } from '../../../context/ModalContext'
import { color } from '../../../GlobalStyle'
import { formatedData } from '../../../hooks/FormatedValue'
import ToolTip from '../Tooltip'
import { Actions, ContainerTable, ProductTable, SelectQtd, TableBody, TableHead } from './style'

import { useMediaQuery } from 'react-responsive'
import { Mask } from '../../../hooks/Mask'
import { breakpoints } from '../../../MediasQueries'
import { Button } from '../Buttons/NormalButtons'
import EditButton from '../Buttons/NormalButtons/EditButton'
import TrashButton from '../Buttons/NormalButtons/TrashButton'
import InputComponent from '../Input'

const MainTable = ({
  products,
  isHomePage,
  padding,
  isFound,
  handleSelect,
  changingQtd,
  index,
  setClickedId,
  setClickedEdit,
  handleTransform,
  height,
  maxHeight,
}) => {
  const { setOpenModal } = useContext(ModalTotalContext)
  const isDesktop = useMediaQuery({ minWidth: breakpoints.lg })
  const handleClicked = (id) => {
    setClickedId(id)
    setOpenModal('deleteComponent')
  }

  const handleClickedEdit = (prod) => {
    setClickedEdit(prod)
    setOpenModal('editComponent')
  }

  return (
    <ContainerTable height={height} maxHeight={maxHeight}>
      <ProductTable padding={padding}>
        <TableHead>
          {isHomePage && (
            <tr>
              <th style={{ width: '14%' }}>N°</th>
              <th style={{ width: '22%' }}>Nome do produto</th>
              <th style={{ width: '10%' }}>Unid</th>
              <th style={{ width: '10%' }}>Qtd</th>
              <th style={{ width: '16%' }}>Valor unitário</th>
              <th style={{ width: '16%' }}>Valor total</th>
              <th style={{ width: '10%' }}></th>
            </tr>
          )}
          {!isHomePage && (
            <tr>
              <th style={{ width: '15%' }}>N°</th>
              <th style={{ width: '22%' }}>Nome do produto</th>
              <th style={{ width: '10%' }}>Unid</th>
              <th style={{ width: '10%' }}>Qtd</th>
              <th style={{ width: '13%' }}>Valor unitário</th>
              <th style={{ width: '13%' }}>Valor total</th>
              <th width={{ width: '17%' }} style={{ minWidth: '180px' }}>
                Qtd/Custo
              </th>
            </tr>
          )}
        </TableHead>
        <tbody>
          {products?.map((val) => {
            return (
              <TableBody key={val.id} rowSelected={!!isFound(val.id)}>
                <td data-label="N°" className={!isHomePage ? 'all' : null}>
                  {!isHomePage && (
                    <Checkbox
                      className="check"
                      checked={isFound(val.id)}
                      onChange={() =>
                        handleSelect(val.id, val.nome, val.valor_unit, val.unidade, val.quantidade)
                      }
                      color="success"
                      sx={{ width: '24px', height: '24px', padding: '0px 3px 0px 0px' }}
                    />
                  )}

                  <span style={{ verticalAlign: 'middle', alignSelf: 'center' }}>
                    {val.id_contexto}
                  </span>
                  {!isHomePage && !isDesktop && (
                    <>
                      <span style={{ verticalAlign: 'middle', alignSelf: 'center' }}>
                        &nbsp;-&nbsp;
                      </span>
                      <span style={{ verticalAlign: 'middle', alignSelf: 'center' }}>
                        {val.nome}&nbsp;
                      </span>
                      <span style={{ verticalAlign: 'middle', alignSelf: 'center' }} id="infos">
                        {val.quantidade}&nbsp;
                        {val.unidade}&nbsp;
                      </span>

                      <span
                        style={{
                          color: color.brand,
                          verticalAlign: 'middle',
                          alignSelf: 'center',
                          marginLeft: 'auto',
                        }}
                      >
                        {Mask.money(val.valor)}&nbsp;
                      </span>
                    </>
                  )}
                </td>
                {(isHomePage || isDesktop) && (
                  <>
                    <td data-label="Nome do produto">{val.nome}</td>
                    <td data-label="Unidade">{val.unidade}</td>
                    <td data-label="Quantidade">{val.quantidade}</td>
                    <td data-label="Valor Unitário">{formatedData(val.valor_unit)}</td>
                    <td data-label="Valor Total">{formatedData(val.valor)}</td>
                  </>
                )}
                {isHomePage && (
                  <td>
                    {
                      <Actions>
                        <ToolTip>
                          <EditButton onClick={() => handleClickedEdit(val)} />
                          <span>Editar</span>
                        </ToolTip>
                        <ToolTip>
                          <TrashButton onClick={() => handleClicked(val.id)} />
                          <span>Excluir</span>
                        </ToolTip>
                        <ToolTip>
                          <Button color="blue">
                            <MdOutlineProductionQuantityLimits
                              style={{ position: 'absolute' }}
                              onClick={() => handleTransform(val)}
                            />
                          </Button>
                          <span>Converter em produto&nbsp;</span>
                        </ToolTip>
                      </Actions>
                    }
                  </td>
                )}

                {!isHomePage && (
                  <td>
                    <SelectQtd>
                      <InputComponent
                        type={'number'}
                        height={'28px'}
                        width={'100%'}
                        disabled={!isFound(val.id)}
                        onChange={(e) => changingQtd(e.target.value, val.id)}
                        value={isFound(val.id) ? index(val.id).quantidade : ''}
                      />
                      <InputComponent
                        width={'100%'}
                        height={'28px'}
                        disabled
                        value={
                          isFound(val.id)
                            ? formatedData(index(val.id).valor_unit * index(val.id).quantidade)
                            : ''
                        }
                      />
                    </SelectQtd>
                  </td>
                )}
              </TableBody>
            )
          })}
        </tbody>
      </ProductTable>
    </ContainerTable>
  )
}
export default MainTable
